/**
 * The CMS Scene the editor currently has open, for modules that are not on
 * the bootstrap path and cannot be handed one.
 *
 * A module-level singleton like the other shared editor state (undo manager,
 * catalog tokens) — `index.ts` owns the lifetime and sets it beside
 * `setExportCmsManager`. Kept in its own file, importing only the type, so
 * nothing that reads it drags `CmsManager`'s import graph into a cycle.
 */

import type { CmsManager } from './CmsManager';

let _active: CmsManager | null = null;

/** Called by `index.ts` on connect and on disconnect (with null). */
export function setActiveCmsManager(manager: CmsManager | null): void {
    _active = manager;
}

/** The open CMS Scene, or null when the editor is on a standalone scene. */
export function getActiveCmsManager(): CmsManager | null {
    return _active;
}
